var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"therapist",attrs:{"id":"dash-root"}},_vm._l((_vm.dashparts),function(dashpart,index){return _c('therapist-create-dash-component',{key:index,staticClass:"panel panel-flat",attrs:{"part":dashpart,"initial-date":_vm.initialDate,"do_refresh":_vm.do_refresh,"is_admin":_vm.is_admin}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }